export default "/images/vendor/@coreui/icons/svg/flag/cif-my.svg?808b8eda4de06f6dfa1c096e1e965ae4";